import { Tab } from '@headlessui/react'
import cx from 'classnames'
import React, { Fragment } from 'react'

const TABS = [
  {
    label: 'درخواست استعلام قیمت',
  },
  {
    label: 'پیگیری درخواست',
  },
  {
    label: 'اتصال به سایر واحد ها',
  },
  {
    label: 'سایر',
  },
]

function TabsList() {
  return (
    <Tab.List className="inline-block bg-white rounded-lg overflow-hidden mb-4">
      {TABS.map((tab, index) => {
        const isLastElement = index === TABS.length - 1

        return (
          <Tab as={Fragment} key={tab.label}>
            {({ selected }) => (
              <button
                className={cx(
                  'text-[#6D6D6D] text-[16px] my-2 font-semibold !outline-none relative px-6',
                  selected && '!text-color-blue-light',
                  !isLastElement && 'border-l-1 border-gray-extra-light'
                )}
              >
                {tab.label}
                {selected && (
                  <div className="absolute bottom-[-8px] right-0 bg-color-blue-light w-full h-1 rounded-1" />
                )}
              </button>
            )}
          </Tab>
        )
      })}
    </Tab.List>
  )
}

export default TabsList
